import PlatonicSolids from "../../../../src/posts/platonic-solids/PlatonicSolids.js";
import * as React from 'react';
export default {
  PlatonicSolids,
  React
};